import React, { Suspense, lazy, useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Home from "./Components/Home";
import DiscoverNow from "./Components/DiscoverNow1";
import { RoutePaths } from "./Constants";
import FreightRates from "./Components/Freightrates1/FreightRates";
import LocationDashboard from "./Components/LocationDashboardv2";
import Trucks from "./Components/TrucksAvailable/TrucksMain";
import Indents from "./Components/Indent/IndentMain";
import SearchEngine from "./Components/Search/Home";
import Searchresults from "./Components/Search/Searchresults";
import Wizard from "./Components/CompanyProfileNew/Wizard/Wizard";
import RealiseSavings from "./Components/BenchmarkNowV2/RealiseSavings";

const TrackDetails = lazy(() =>
  import("./Components/Indent/TrackAndTrace/TrackDetails")
);

const MasterTrackingDashboard = lazy(() =>
  import("./Components/Indent/MasterTrackingDashboard/Dashboard")
);

const MasterDashboard = lazy(() =>
  import("./Components/MasterDashboard/MasterDashboard")
);

const BenchmarkNowV2 = lazy(() =>
  import("./Components/BenchmarkNowV2/BenchmarkNowV2")
);

const BenchmarkV3 = lazy(() =>
  import("./Components/BenchmarkV3/BenchmarkV3")
);


// NEW LAZY LOADED IMPORTS
const Sitemap = lazy(() => import("./Components/Sitemap/Sitemap"));
const RFQCalender = lazy(() => import("./Components/RFQCalender/RFQCalender"));
const ChangePassword = lazy(() =>
  import("./Components/ForgotPassword/ChangePassword")
);
const SynergyNow = lazy(() => import("./Components/SynergyNow/SynergyNow"));
const GSTNOW = lazy(() =>
  import("./Components/SynergyNow/SynergyNowUpload/GSTNOW")
);
const Main = lazy(() => import("./Components/GateIn-GateOut/Main"));

// old invoice
const Invoice = lazy(() => import("./Components/Indent/Invoice/Invoice"));
const InvoiceDetails = lazy(() =>
  import("./Components/Indent/Invoice/InvoiceDetails")
);

// new invoice
const NewInvoice = lazy(() =>
  import("./Components/Indent/InvoiceV2/NewInvoice")
);
const NewInvoiceDetails = lazy(() =>
  import("./Components/Indent/InvoiceV2/NewInvoiceDetails")
);

const TransporterDetails = lazy(() =>
  import("./Components/TransporterDetails")
);
const MyTransporters = lazy(() => import("./Components/MyTransporters"));
const TransportersList = lazy(() => import("./Components/TransportersList"));

const MyAccount = lazy(() => import("./Components/MyAccount"));
const LorriInMail = lazy(() =>
  import("./Components/MyAccount/LorriInMail/LorriInMail")
);
const Billing = lazy(() =>
  import("./Components/Billing&Payment/BillingUpdated")
);
const ContractNow = lazy(() => import("./Components/ContractNow/ContractNow"));
const TransportComparison = lazy(() =>
  import("./Components/TransportComparison/TransportComparison")
);
const Dashboard = lazy(() => import("./Components/Dashboard/DashboardMain"));
// const CompanyProfileDetails = lazy(() =>
//   import("./Components/CompanyProfileDetails/CompanyProfileDetails")
// );
const CapacityPlanning = lazy(() => import("./Components/CapacityPlanning"));
const TransporterClientScreen = lazy(() =>
  import("./Components/TransporterClientScreen")
);
const ApprovalControl = lazy(() =>
  import("./Components/ApprovalControl/ApprovalMains")
);

const ProcurementLaneDetails = lazy(() =>
  import("./Components/ApprovalControl/Procurement/ProcurementLaneDetails")
);

// planning
const RePlanning = lazy(() => import("./Components/Planning/Replanning"));
const NotAllowed = lazy(() => import("./Components/NotAllowed"));

// breaking css on lazy imports
const Unauthorized = lazy(() => import("./Components/Unauthorized"));
// const Home = lazy(() => import("./Components/Home"));
// const Searchresults = lazy(() => import("./Components/Search/Searchresults"));
// const SearchEngine = lazy(() => import("./Components/Search/Home"));

const RouterOutlet = ({ landing_page }) => {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.includes("trucks")) {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }
  }, [location]);

  return (
    <Suspense fallback={<div></div>}>
      <Switch>
        <Route path="/discovernow" component={DiscoverNow} exact />
        <Route path="/rfqcalender" component={RFQCalender} />{" "}
        <Route path="/approvalcontrol/:id" component={ApprovalControl} exact />
        <Route path="/procurement/:procurementId/lanes" component={ProcurementLaneDetails} exact />
        <Route path="/trucks" component={Trucks} />
        <Route path="/gigo/:id" component={Main} exact />
        <Route path={RoutePaths.MyAccount} component={MyAccount} exact />
        <Route path="/myTransporters" component={MyTransporters} />
        <Route
          path="/transporters/:name"
          component={TransporterDetails}
          exact
        />
        {/* <Route path="/transporters" component={TransportersList} exact /> */}
        <Route path="/companyprofilenew/:id" component={Wizard} />
        <Route path="/tpmp" component={TransporterClientScreen} exact />
        <Route path="/tpmp/:name" component={TransporterClientScreen} exact />
        <Route
          path="/TransportComparison"
          component={TransportComparison}
          exact
        />
        <Route path="/SynergyNow" component={SynergyNow} exact />
        <Route path="/GST" component={GSTNOW} exact />
        <Route path="/unauthorized" component={Unauthorized} exact />
        <Route path="/Home" component={Home} />
        <Route path="/NotAllowed" component={NotAllowed} exact />
        <Route path="/locationdashboard" component={LocationDashboard} exact />
        <Route path="/old/benchmarknow" component={FreightRates} exact />
        <Redirect from="/benchmarknow" to="/LoRRIBenchmark" exact />
        <Route path="/LoRRIBenchmark" component={BenchmarkV3} />
        <Route path="/benchmark-v3" component={BenchmarkV3} />
        <Redirect from="/benchmark" to="/LoRRIBenchmark" exact />
        <Route path="/lockinyoursavings" component={RealiseSavings} exact />
        <Route path="/contractnow" component={ContractNow} exact />
        <Route path="/LorriInMail" component={LorriInMail} exact />
        <Route path="/billing" component={Billing} exact />
        <Route path="/SearchResults" component={Searchresults} exact />
        <Route path="/SearchEngine" component={SearchEngine} exact />
        <Route path="/indent:id" component={Indents} />
        <Route
          path="/capacityplanning/:id"
          component={CapacityPlanning}
          exact
        />
        <Route path="/old/invoice" component={Invoice} exact />
        <Route path="/invoice" component={NewInvoice} exact />
        <Route path="/invoice/view/:invoiceId" component={NewInvoiceDetails} />
        <Route path="/old/invoice/:id" component={InvoiceDetails} exact />
        <Route path="/old/dashboard" component={Dashboard} exact />
        <Redirect from="/dashboard" to="/master_dashboard/spotoverview" exact />
        <Route path="/trackingdetails/:indent_id/:indent_id_sub" component={TrackDetails} exact />
        <Route path="/tracking_dashboard" component={MasterTrackingDashboard} exact />

        <Redirect from="/master_dashboard" to="/master_dashboard/spotoverview" exact />
        <Route
          path="/master_dashboard/:tab(indentsummary|vehiclestatus|vehicleallocation|spotoverview)"
          component={MasterDashboard}
          exact
        />
        <Route path="/planning/:id" component={RePlanning} exact />
        {/* <Route
          path="/company_profile"
          component={CompanyProfileDetails}
          exact
        /> */}
        <Route path="/change-password" component={ChangePassword} exact />
        <Route path="/sitemap" component={Sitemap} />
        <Redirect from="/" to={`/${landing_page}`} />
      </Switch>
    </Suspense>
  );
};

export default RouterOutlet;
